var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// oauth-provider/oauth2Login.ts
import { Arg, Entity, Field, Mutation } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { OAuth2Server } from "./server/server.js";
import { registerMutation } from "@adornis/baseql/metadata/register.js";
var OAuth2Login = class extends AdornisEntity {
  static authorizeOAuth(loginData) {
    return async () => {
      return OAuth2Server.get().authorize(loginData.toJSON());
    };
  }
};
OAuth2Login._class = "OAuth2Login";
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "client_id", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "code_challenge", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "code_challenge_method", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "redirect_uri", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "response_type", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "scope", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "state", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "username", 2);
__decorateClass([
  Field((type) => String)
], OAuth2Login.prototype, "password", 2);
__decorateClass([
  Mutation((type) => String),
  __decorateParam(0, Arg("loginData", (type) => OAuth2Login))
], OAuth2Login, "authorizeOAuth", 1);
OAuth2Login = __decorateClass([
  Entity()
], OAuth2Login);
var authorizeOAuth = registerMutation({
  operationName: "authorizeOauth",
  resolve: (loginData) => async () => OAuth2Server.get().authorize(loginData.toJSON()),
  type: () => String,
  params: [{ name: "loginData", type: () => OAuth2Login }]
});
export {
  OAuth2Login,
  authorizeOAuth
};
